<template>
  <div>
    <el-dialog
      :visible.sync="visable"
      title="新建短信"
      width="80%"
      :before-close="closeDialog"
      top="5vh"
    >
      <el-button size="mini" @click="send()">立即发送</el-button>
      <el-button size="mini" @click="saveAsDraft()">存为草稿</el-button>
      <el-divider content-position="left">信息提示</el-divider>
      <span
        >当前用户：{{ loginName }} 您可发送短信{{ canSend }}条 已发送{{
          used
        }}条。</span
      >
      <el-divider content-position="left">
        短信内容 内容长度：{{ strLength }} 短信模版：{{ templateName }}
      </el-divider>
      <el-row>
        <el-col :span="20">
          <el-input
            v-model="content"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            placeholder="请输入短信内容"
            :show-word-limit="true"
          />
        </el-col>
        <el-col :span="4">
          <el-link
            type="primary"
            icon="el-icon-edit"
            :underline="false"
            @click="templateTree"
          >
            选择短信模版
          </el-link>
        </el-col>
      </el-row>
      <span style="color: #00cd66">提示：</span>
      <span>可以直接输入短信内容，也可以通过短信模板选择短信内容。</span>
      <p style="color: crimson" v-if="warnning">
        短信内容超出70字符，此短信将被分割成{{ sendNum }}条短信发送！
      </p>
      <el-divider content-position="left">
        发送号码 数量：{{ phoneNumber }}
      </el-divider>
      <el-row>
        <el-col :span="1">
          <el-link type="primary" @click="append" :underline="false">
            添加
          </el-link>
        </el-col>
        <el-col :span="1">
          <el-link type="primary" @click="del" :underline="false">
            删除
          </el-link>
        </el-col>
        <el-col :span="1">
          <el-link type="primary" @click="openExport" :underline="false">
            导入
          </el-link>
        </el-col>
<!--        <el-col :span="3">-->
<!--          <el-link-->
<!--            type="primary"-->
<!--            @click="house(2)"-->
<!--            :underline="false"-->
<!--            icon="el-icon-s-custom"-->
<!--          >-->
<!--            发送欠费客户-->
<!--          </el-link>-->
<!--        </el-col>-->
        <el-col :span="3">
          <el-link
            type="primary"
            @click="house(1)"
            :underline="false"
            icon="el-icon-s-custom"
          >
            选择发送客户
          </el-link>
        </el-col>
        <el-col :span="3">
          <user-select
            :selectType="2"
            showName="选择发送员工"
            :modal="false"
            @on-select="onUserSelect"
          />
        </el-col>
        <el-col :span="3">
          <el-link
            type="primary"
            @click="delAll()"
            :underline="false"
            icon="el-icon-delete"
          >
            清除发送对象
          </el-link>
        </el-col>
      </el-row>
      <el-table
        :data="phoneList"
        max-height="400"
        @selection-change="handleSelectionChange"
        v-loading="loading"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column label="房号">
          <template slot-scope="data">
            <el-input
              v-model="data.row.houseName"
              size="mini"
              width="200"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="客户姓名">
          <template slot-scope="data">
            <el-input
              v-model="data.row.name"
              size="mini"
              width="200"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="手机号码">
          <template slot-scope="data">
            <el-input
              v-model="data.row.phone"
              size="mini"
              width="200"
            ></el-input>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <sms-template-tree
      :visable.sync="treeVisable"
      @close="closeTree"
      @node-click="treeNodeClick"
    />
    <!-- 房产 -->
    <house ref="house" />
    <el-dialog
      :visible.sync="exportVisable"
      title="导入"
      width="30%"
      :before-close="closeExport"
      top="5vh"
    >
      <el-upload
        :action="url"
        :before-remove="beforeRemove"
        :limit="1"
        :on-success="handleSuccess"
        :file-list="fileList"
      >
        <el-button size="mini" type="primary">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">只能上传txt文件</div>
      </el-upload>
    </el-dialog>
  </div>
</template>

<script>
import SmsTemplateTree from "@/components/Admin/Butler/SmsTemplateTree";
import userSelect from "@/components/common/userSelect.vue";
import House from "@/components/Admin/Forms/common/SelectProjectHouse";
import _ from "lodash";
export default {
  name: "SmsSend",
  components: { SmsTemplateTree, userSelect, House },
  props: {
    visable: {
      type: Boolean,
      default: false,
    },
    user_list:{
      type: Array,
      default: [],
    }
  },
  data() {
    return {
      loginName: "",
      strLength: 0,
      templateName: "",
      templateId: 0,
      content: "",
      treeVisable: false,
      phoneNumber: 0,
      warnning: false,
      phoneList: [],
      selection: [],
      loading: false,
      sendNum: 0,
      exportVisable: false,
      fileList: [],
      url: "",
      canSend: 0,
      used: 0,
    };
  },
  mounted() {
    this.loginName = window.localStorage.getItem("login");
    var token = window.localStorage.getItem("token");
    var oa_user_id = window.localStorage.getItem("oa_user_id");
    this.url =
      this.$myhttp.defaults.baseURL +
      "/admin/Sms/exportTxt?" +
      "login_name=" +
      this.loginName +
      "&token=" +
      token +
      "&oa_user_id=" +
      oa_user_id;
    this.getLimit();
  },
  watch: {
    content(n, o) {
      this.strLength = this.content.length;
      if (this.strLength > 64 && this.strLength <= 131) {
        this.warnning = true;
        this.sendNum = 2;
      } else if (this.strLength > 131) {
        this.warnning = true;
        const num = Math.ceil((this.strLength - 131) / 67);
        this.sendNum = num + 2;
      } else {
        this.sendNum = 1;
      }
    },
    phoneList(n, o) {
      this.phoneNumber = this.phoneList.length;
    },
    user_list(phoneList){
      const _this=this;
      _this.phoneList=[];
      phoneList.map((item) => {
        const last = _.last(_this.phoneList);
        let id = 1;
        if (_this.phoneList.length > 0) {
          id = last.id + 1;
        }
        const obj = {
          id: id,
          pindexId: _.get(item, "pindexId", 0),
          houseName: _.get(item, "address", ""),
          customerId: _.get(item, "customerId", 0),
          name: _.get(item, "name", ""),
          phone: _.get(item, "phone", ""),
        };
        _this.phoneList.push(obj);
      });
    }
  },
  methods: {
    closeDialog() {
      this.$emit("close", false);
    },
    templateTree() {
      this.treeVisable = true;
    },
    closeTree() {
      this.treeVisable = false;
    },
    treeNodeClick(data) {
      this.content = _.get(data, "content", "");
      this.templateName = _.get(data, "name", "");
      this.templateId = _.get(data, "id", 0);
    },
    handleSelectionChange(data) {
      this.selection = data;
    },
    append() {
      const last = _.last(this.phoneList);
      let id = 1;
      if (this.phoneList.length > 0) {
        id = last.id + 1;
      }
      const data = {
        id: id,
        pindexId: 0,
        houseName: "",
        customerId: 0,
        name: "",
        phone: "",
      };
      this.phoneList.push(data);
    },
    del() {
      var objects = _.differenceWith(this.phoneList, this.selection, _.isEqual);
      this.phoneList = objects;
    },
    delAll() {
      this.phoneList = [];
    },
    send() {
      if (this.phoneList.length == 0) {
        this.$message.error("请输入发送对象");
        return;
      }
      if (this.content.length == 0) {
        this.$message.error("请输入短信内容");
        return;
      }
      const loading = this.$loading({ fullscreen: true });
      const param = {
        templateId: this.templateId,
        phoneList: this.phoneList,
        content: this.content,
        sendNum: this.sendNum,
      };
      this.$myhttp
        .post("admin/Sms/sendSms", param, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.$message.success(res.data.msg);
          } else {
            this.$message.error(res.data.msg);
          }
          loading.close();
          this.closeDialog();
        })
        .catch((err) => {
          this.$message.error(err.msg);
          loading.close();
        });
    },
    onUserSelect(data) {
      data.map((item) => {
        const last = _.last(this.phoneList);
        let id = 1;
        if (this.phoneList.length > 0) {
          id = last.id + 1;
        }
        const obj = {
          id: id,
          pindexId: 0,
          houseName: "",
          customerId: 0,
          name: _.get(item, "name", ""),
          phone: _.get(item, "phone_number", ""),
        };
        this.phoneList.push(obj);
      });
    },
    house(type) {
      let _this = this;
      this.$refs.house.show([], function (data) {
        let param = { houseIds: data, type };
        this.$myhttp
          .post("admin/Common/searchCustomer", param, {
            "Content-Type": "application/x-www-form-urlencoded",
          })
          .then((backdata) => {
            // 异步执行成功后
            if (backdata.data.code == 200) {
              const res = backdata.data.data;
              res.map((item) => {
                const last = _.last(_this.phoneList);
                let id = 1;
                if (_this.phoneList.length > 0) {
                  id = last.id + 1;
                }
                const obj = {
                  id: id,
                  pindexId: _.get(item, "pindexId", 0),
                  houseName: _.get(item, "address", ""),
                  customerId: _.get(item, "customerId", 0),
                  name: _.get(item, "name", ""),
                  phone: _.get(item, "phone", ""),
                };
                _this.phoneList.push(obj);
              });
            } else {
              _this.$message.error(backdata.data.msg);
            }
          });
      });
    },
    openExport() {
      this.exportVisable = true;
    },
    closeExport() {
      this.exportVisable = false;
    },
    handleSuccess(response) {
      if (response.code == 200) {
        let res = response.data;
        res.map((item) => {
          const last = _.last(this.phoneList);
          let id = 1;
          if (this.phoneList.length > 0) {
            id = last.id + 1;
          }
          const obj = {
            id: id,
            pindexId: 0,
            houseName: "",
            customerId: 0,
            name: "",
            phone: item,
          };
          this.phoneList.push(obj);
        });
        this.closeExport();
      } else {
        this.$message.error(response.msg);
      }
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    saveAsDraft() {
      if (this.phoneList.length == 0) {
        this.$message.error("请输入发送对象");
        return;
      }
      if (this.content.length == 0) {
        this.$message.error("请输入短信内容");
        return;
      }
      const loading = this.$loading({ fullscreen: true });
      const param = {
        templateId: this.templateId,
        phoneList: this.phoneList,
        content: this.content,
        sendNum: this.sendNum,
      };
      this.$myhttp
        .post("admin/Sms/saveSms", param, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.$message.success("保存成功");
          } else {
            this.$message.error(res.data.msg);
          }
          loading.close();
          this.closeDialog();
        })
        .catch((err) => {
          this.$message.error(err.msg);
          loading.close();
        });
    },
    getLimit() {
      this.$myhttp
        .post(
          "admin/Sms/getSmsLimit",
          {},
          {
            "Content-Type": "application/x-www-form-urlencoded",
          }
        )
        .then((res) => {
          if (res.data.code == 200) {
            this.canSend = res.data.data.usable_msg_num;
            this.used = res.data.data.send_msg_num;
          }
        });
    },
  },
};
</script>

<style>
.margin-top {
  margin-top: 10px;
}
.margin-left {
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/SmsSend.vue